import { pdfPickerPtBR, pdfPickerEnUS, pdfPickerEsES } from "./trail-pdf-picker-messages";

export const trailChatV3PtBR = {
  pdfPicker: pdfPickerPtBR,
  savingBrief: "Salvando seus objetivos…",
  stopping: "Interrompendo a resposta…",
  updating: "Atualizando a alteração…",
  assistant: "Professor Gamefik",
  you: "Você",
  latest: "Ir para o fim",
  sending: "Enviando seu pedido…",
  cancelled: "Resposta interrompida. Você pode continuar a conversa.",
  failed: "Não consegui concluir esta resposta. Tente novamente.",
  correctAnswer: "Resposta correta",
  expectedAnswer: "Resposta esperada",
  true: "Verdadeiro",
  false: "Falso",
  openReference: "Ver atividade",
  duplicateFile: "Há arquivos com o mesmo nome. Renomeie um deles para escolher o uso de cada material.",
  retryRequest: "Tentar este pedido novamente",
  title: "Chat IA v3",
  hmg: "Experimental · Homologação",
  tryV3: "Experimentar Chat IA v3 · HMG",
  brief: "Objetivos e preferências",
  saveBrief: "Salvar contexto",
  loading: "Carregando conversa",
  welcome: "O que vamos criar? Conte sua ideia ou envie um material para começarmos.",
  placeholder: "Peça uma alteração, envie um material ou faça uma pergunta…",
  sources: "Materiais da conversa",
  material: "Material",
  page: "Página",
  revisions: "Histórico de alterações",
  proposed: "Aguardando sua escolha",
  applied: "Aplicado",
  rejected: "Descartado",
  undone: "Desfeito",
  includeChange: "Incluir esta alteração",
  before: "Antes",
  after: "Depois",
  apply: "Aplicar seleção",
  reject: "Descartar",
  undo: "Desfazer",
  working: "Preparando sua resposta…",
  cancel: "Interromper",
  send: "Enviar",
  attach: "Anexar PDF ou imagem",
  remove: "Remover",
  sourceMode: "Como usar",
  auto: "Conforme meu pedido",
  study: "Base de estudo",
  faithfulCopy: "Copiar exercícios 1:1",
  adapt: "Adaptar atividades",
  previewFirst: "Mostrar prévia antes de aplicar",
  actionError: "Não foi possível concluir a alteração. Atualize a conversa e tente novamente.",
  sendError: "Não foi possível confirmar o envio. Seu texto e arquivos foram mantidos. Tente enviar novamente.",
  fileError: "Alguns arquivos não foram adicionados. Use até 4 PDFs ou imagens, de até 50 MB cada e 100 MB no total.",
};

export const trailChatV3EnUS: Record<Exclude<keyof typeof trailChatV3PtBR, "pdfPicker">, string> & { pdfPicker: typeof pdfPickerEnUS } = {
  pdfPicker: pdfPickerEnUS,
  savingBrief: "Saving your goals…",
  stopping: "Stopping the response…",
  updating: "Updating the change…",
  assistant: "Professor Gamefik",
  you: "You",
  latest: "Jump to latest",
  sending: "Sending your request…",
  cancelled: "Response stopped. You can continue the conversation.",
  failed: "I couldn't finish this response. Please try again.",
  correctAnswer: "Correct answer",
  expectedAnswer: "Expected answer",
  true: "True",
  false: "False",
  openReference: "View activity",
  duplicateFile: "Some files have the same name. Rename one to choose how each material should be used.",
  retryRequest: "Try this request again",
  title: "AI Chat v3",
  hmg: "Experimental · Staging",
  tryV3: "Try AI Chat v3 · HMG",
  brief: "Goals and preferences",
  saveBrief: "Save context",
  loading: "Loading conversation",
  welcome: "What shall we create? Describe your idea or upload material to get started.",
  placeholder: "Request a change, upload material or ask a question…",
  sources: "Conversation materials",
  material: "Material",
  page: "Page",
  revisions: "Change history",
  proposed: "Awaiting your choice",
  applied: "Applied",
  rejected: "Discarded",
  undone: "Undone",
  includeChange: "Include this change",
  before: "Before",
  after: "After",
  apply: "Apply selection",
  reject: "Discard",
  undo: "Undo",
  working: "Preparing your response…",
  cancel: "Stop",
  send: "Send",
  attach: "Attach PDF or image",
  remove: "Remove",
  sourceMode: "How to use",
  auto: "Follow my request",
  study: "Study material",
  faithfulCopy: "Copy exercises 1:1",
  adapt: "Adapt activities",
  previewFirst: "Show preview before applying",
  actionError: "The change could not be completed. Refresh the conversation and try again.",
  sendError: "We could not confirm delivery. Your text and files were kept. Try sending again.",
  fileError: "Some files were not added. Use up to 4 PDFs or images, up to 50 MB each and 100 MB total.",
};

export const trailChatV3EsES: Record<Exclude<keyof typeof trailChatV3PtBR, "pdfPicker">, string> & { pdfPicker: typeof pdfPickerEsES } = {
  pdfPicker: pdfPickerEsES,
  savingBrief: "Guardando tus objetivos…",
  stopping: "Interrumpiendo la respuesta…",
  updating: "Actualizando el cambio…",
  assistant: "Profesor Gamefik",
  you: "Tú",
  latest: "Ir al final",
  sending: "Enviando tu solicitud…",
  cancelled: "Respuesta interrumpida. Puedes continuar la conversación.",
  failed: "No pude completar esta respuesta. Inténtalo de nuevo.",
  correctAnswer: "Respuesta correcta",
  expectedAnswer: "Respuesta esperada",
  true: "Verdadero",
  false: "Falso",
  openReference: "Ver actividad",
  duplicateFile: "Hay archivos con el mismo nombre. Cambia el nombre de uno para elegir cómo usar cada material.",
  retryRequest: "Intentar esta solicitud de nuevo",
  title: "Chat IA v3",
  hmg: "Experimental · Homologación",
  tryV3: "Probar Chat IA v3 · HMG",
  brief: "Objetivos y preferencias",
  saveBrief: "Guardar contexto",
  loading: "Cargando conversación",
  welcome: "¿Qué vamos a crear? Describe tu idea o adjunta un material para comenzar.",
  placeholder: "Pide un cambio, adjunta un material o haz una pregunta…",
  sources: "Materiales de la conversación",
  material: "Material",
  page: "Página",
  revisions: "Historial de cambios",
  proposed: "Esperando tu elección",
  applied: "Aplicado",
  rejected: "Descartado",
  undone: "Deshecho",
  includeChange: "Incluir este cambio",
  before: "Antes",
  after: "Después",
  apply: "Aplicar selección",
  reject: "Descartar",
  undo: "Deshacer",
  working: "Preparando tu respuesta…",
  cancel: "Interrumpir",
  send: "Enviar",
  attach: "Adjuntar PDF o imagen",
  remove: "Eliminar",
  sourceMode: "Cómo usar",
  auto: "Según mi solicitud",
  study: "Material de estudio",
  faithfulCopy: "Copiar ejercicios 1:1",
  adapt: "Adaptar actividades",
  previewFirst: "Mostrar vista previa antes de aplicar",
  actionError: "No se pudo completar el cambio. Actualiza la conversación e inténtalo de nuevo.",
  sendError: "No pudimos confirmar el envío. Conservamos tu texto y archivos. Intenta enviarlos de nuevo.",
  fileError: "No se añadieron algunos archivos. Usa hasta 4 PDF o imágenes, de hasta 50 MB cada uno y 100 MB en total.",
};
